/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationPublicDataBuilderFxLauncherOptions interface.
 */
export function instanceOfFxIdApplicationPublicDataBuilderFxLauncherOptions(value) {
    if (!('GameSearchPaths' in value) || value['GameSearchPaths'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationPublicDataBuilderFxLauncherOptionsFromJSON(json) {
    return FxIdApplicationPublicDataBuilderFxLauncherOptionsFromJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderFxLauncherOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'AdditionalLauncherArguments': json['AdditionalLauncherArguments'] == null ? undefined : json['AdditionalLauncherArguments'],
        'GameSearchPaths': json['GameSearchPaths'],
    };
}
export function FxIdApplicationPublicDataBuilderFxLauncherOptionsToJSON(json) {
    return FxIdApplicationPublicDataBuilderFxLauncherOptionsToJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderFxLauncherOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'AdditionalLauncherArguments': value['AdditionalLauncherArguments'],
        'GameSearchPaths': value['GameSearchPaths'],
    };
}
//# sourceMappingURL=FxIdApplicationPublicDataBuilderFxLauncherOptions.js.map